import styled from 'styled-components';
import { COLORS } from 'styles/constants';
import tw from 'tailwind-styled-components';
import { Text as Paragraph, Title } from '../../components/Typography';

export const Container = tw.div`
  py-4
  sm:w-full
  md:w-1/2
  form-fields
`;
Container.displayName = 'Container';

export const AccordionContainer = styled.div`
  .form-fields {
    width: 100%;
  }
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  border: 2px solid ${COLORS.primary};
  border-radius: 16px;
  display: block;
  margin-bottom: 10px;
  padding: 10px 20px;
  width: 100%;
  &:focus {
    border-color: var(--gray-500);
    box-shadow: none;
  }

  ${({ $hasError }) =>
    $hasError &&
    `
      border-color: ${COLORS.error};
    `}
`;
Input.displayName = 'Input';

export const Select = styled.select<{ $hasError?: boolean }>`
  border: 2px solid ${COLORS.primary};
  border-radius: 16px;
  display: block;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px 20px;
  width: 100%;

  &:focus {
    border-color: var(--gray-500);
    box-shadow: none;
  }

  ${({ $hasError }) =>
    $hasError &&
    `
      border-color: ${COLORS.error};
    `}

  option {
    width: 100%;
  }
`;
Select.displayName = 'Select';

export const Textarea = styled.textarea<{ $hasError?: boolean }>`
  border: 2px solid ${COLORS.primary};
  border-radius: 16px;
  display: block;
  margin-bottom: 10px;
  padding: 10px 20px;
  width: 100%;
  overflow: hidden;

  &:focus {
    border-color: var(--gray-500);
    box-shadow: none;
  }

  ${({ $hasError }) =>
    $hasError &&
    `
      border-color: ${COLORS.error};
    `}
`;
Textarea.displayName = 'Textarea';

export const Label = styled.label`
  color: #5a5e5a;
  font-size: 14px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 2.1px;
`;
Label.displayName = 'Label';

export const ErrorMessage = styled.p`
  color: ${COLORS.error};
  margin: 0;
`;
ErrorMessage.displayName = 'ErrorMessage';

export const SuccessMessage = styled(Title)`
  color: #5a5e5a;
  margin: 0;
  margin-top: 40px;
`;
SuccessMessage.displayName = 'SuccessMessage';

export const SuccessDescription = styled(Paragraph)`
  color: #5a5e5a;
  margin: 20px 0;
`;
SuccessDescription.displayName = 'SuccessDescription';

export const CheckboxInput = styled.input<{ $hasError?: boolean }>`
  margin-right: 10px;
  border: 2px solid ${COLORS.primary};
  margin-top: 5px;
  vertical-align: top;
  outline: transparent;

  &:checked,
  &:checked:hover {
    background-color: var(--gray-500);
  }
  &:checked:focus {
    background-color: ${COLORS.primary};
  }
  &:focus {
    --tw-ring-color: var(--green-500);
    --tw-ring-offset-width: 0;
  }
  &:disabled {
    background-color: transparent;
    border-color: var(--lightgray);
  }
  &:checked:disabled {
    border-color: var(--lightgray);
    background-color: var(--lightgray);
  }

  ${({ $hasError }) =>
    $hasError &&
    `
      border-color: ${COLORS.error};
    `}
`;
CheckboxInput.displayName = 'CheckboxInput';

export const SubmitInput = styled.input`
  padding: 1.25rem 2rem;
  border: 2px solid ${COLORS.primary};
  border-radius: 1.5rem;
  background-color: transparent;
  text-transform: uppercase;
`;
SubmitInput.displayName = 'SubmitInput';

export const StyledSubmitButton = tw.button`
  w-max
`;
StyledSubmitButton.displayName = 'StyledSubmitButton';

export const FormElements = tw.div`
  sm:w-full
  inline-block
  align-top
  md:mr-6
  sm:mr-0
`;
FormElements.displayName = 'FormElements';

export const FormLabel = tw(Paragraph)`
  inline-block
  w-full
  pb-5
  form-text
`;
FormLabel.displayName = 'FormLabel';

export const OptionsBox = tw.ul`
  rounded-2xl
  w-full
  border
  border-grayBorder
  p-0
  bg-light-brown
  max-h-countrySelectorHeight
  overflow-auto
  mt-2.5
`;
OptionsBox.displayName = 'OptionsBox';

export const OptionWrapper = styled.li`
  min-height: 60px;
  &:first-child {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  &:last-child {
    border-bottom: 0;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
  &.selected {
    background-color: ${COLORS.primary};
    border-color: #5a5e5a;
    label {
      color: ${COLORS.white};
    }
  }
`;
OptionWrapper.displayName = 'OptionWrapper';

export const OptionLabel = tw.label`
  block
  py-18
  px-5
  font-neutral
  tracking-wider
  text-sm
  text-darkgray
`;
OptionLabel.displayName = 'OptionLabel';

export const MainLabel = tw.label`
  inline-block
  w-full
  relative
`;
MainLabel.displayName = 'MainLabel';

export const LeftIcon = tw.span`
  absolute
  left-5
  bottom-1.5
`;
LeftIcon.displayName = 'LeftIcon';

export const SuccessWrapper = styled.div<{ $scroll?: boolean }>`
  text-align: center;
  margin: 70px 20px;
  svg {
    margin: auto;
  }
  @media (max-width: 480px) {
    margin: 60px 20px 75px;
  }
  ${({ $scroll }) => $scroll && 'scroll-margin-top: 100px;'}
`;
SuccessWrapper.displayName = 'SuccessWrapper';

export const ButtonFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -33px;
`;

ButtonFlexContainer.displayName = 'ButtonFlexContainer';

export const CheckboxCollectionDiv = tw.div`
  pt-5
`;
export const CollectionCheckbox = tw.label`
  pr-5
`;
export const StyledCollectionCheckbox = styled.label`
  padding-right: 1.25rem;

  input:disabled + span {
    color: var(--lightgray);
  }
`;
export const StyledLabel = styled.label`
  input:disabled + p {
    color: var(--lightgray);
    pr-8
  }
`;
export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  input:disabled + span {
    color: var(--lightgray);
  }
  span {
    margin-left: 5px;
  }
`;
export const RadioButton = tw.div`
  pr-5
  inline-block
  pt-5
`;
export const RadioInput = styled.input`
  color: var(--gray-500);

  &:focus {
    --tw-ring-color: transparent;
    --tw-ring-offset-width: 0;
  }
  &:focus::before {
    content: '';
    display: block;
    width: 43%;
    height: 43%;
    border-radius: 50%;
    background: transparent;
    outline: 4px solid ${COLORS.primary};
    outline-offset: 0px;
    margin: 28% auto;

    @media (min-width: 768px) {
      margin: 29% auto;
    }
  }
  &:disabled {
    background-color: transparent;
    border-color: var(--lightgray);
  }
  &:checked:disabled {
    border-color: var(--lightgray);
    background-color: var(--lightgray);
  }
`;

export const CheckboxLabel = tw.div`
  inline-block
  w-11/12
  m-0
`;
export const CheckboxLabelHtml = tw.div`
  flex
`;
export const WarningIconSpan = tw.span`
  absolute
  right-6
  bottom-5
  w-6
  h-6
  md:right-5
  md:w-5
  md:h-5

  ${(p: { $isDate?: boolean }) =>
    p.$isDate ? 'mr-7 mb-0.5 md:mr-6 md:pt-1 md:right-6 md:bottom-6' : ''}
 `;

export const CheckIconSpan = tw.span`
  absolute
  right-6
  bottom-6
  w-4
  h-4

  ${(p: { $isDate?: boolean }) => (p.$isDate ? 'mr-7 mb-0.5' : '')}
 `;

export const FileUploadContainer = tw.div`
  sm:w-full
  md:w-1/2
  form-fields
  border-green-curve
  border-1
  border-dashed
  rounded-2xl
  py-10
  px-6
  flex
  flex-col
  justify-center
  hover:bg-gray
`;

export const FileUploadWrapper = tw.div`
  flex
  flex-col
  gap-y-8
`;

export const FileButtonWrapper = tw.div`
  flex
  justify-center
`;

export const FileInput = tw.input`
  hidden
`;

export const FileButton = tw.button`
  flex
  gap-x-2.5
  border
  border-black
  rounded-3xl
  py-2
  px-5
  text-sm
  uppercase
  tracking-xl
  leading-6
`;

export const FileUploadText = tw.div`
  text-center
  text-sm
  tracking-wide
  leading-6
`;

export const FileStatusText = tw.div`
  text-center
  tracking-wide
  leading-6
`;

export const FileStatusTextIcon = tw.div`
  tracking-wide
  leading-6
  flex
  justify-center
  gap-x-4
`;

export const FileStatusButton = tw.button`
  border
  border-black
  rounded-3xl
  py-2
  px-5
  text-sm
  uppercase
  tracking-xl
  leading-6

`;

export const UploadErrorMessage = tw.div`
  sm:w-full
  md:w-1/2
  mt-5
  flex
  items-center
  gap-x-5
  text-error
`;
